import Shop from '../shop';

export default class PaperDelivery extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Paper delivery',
            id:                   'PaperDelivery',
            coolDown:             10,
            faClass:              'fa-newspaper-o',
            individualCostFactor: 1.15,
            baseEarnings:         66.0,
            baseCosts:            60.0,
            grade:                2
        });
    }
}
